module.exports = __webpack_public_path__ + "src/assets/images/disabled_download_icon.1b39aa36376e239e4ed6a3dd2670f9bf.svg";